module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQAQMAAAC6caSPAAAAA1BMVEX///+nxBvIAAAAKklEQVR42u3BMQEAAADCoPVP7W8GoAAAAAAAAAAAAAAAAAAAAAAAAACAN0+wAAGUQRhcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.png
// module id = 3xxH
// module chunks = 1